import { render, staticRenderFns } from "./elePage2.vue?vue&type=template&id=3ce2805a&scoped=true&"
import script from "./elePage2.vue?vue&type=script&lang=js&"
export * from "./elePage2.vue?vue&type=script&lang=js&"
import style0 from "./elePage2.vue?vue&type=style&index=0&id=3ce2805a&scoped=true&lang=css&"
import style1 from "./elePage2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce2805a",
  null
  
)

export default component.exports